import React from 'react';
import { connect } from 'react-redux';
import { ModalTransition } from '@atlaskit/modal-dialog';
import AbstractDialogContainer, { abstractMapStateToProps, } from 'jitsi/base/dialog/components/AbstractDialogContainer';
/**
 * Implements a DialogContainer responsible for showing all dialogs. Necessary
 * for supporting @atlaskit's modal animations.
 *
 * @extends AbstractDialogContainer
 */
class DialogContainer extends AbstractDialogContainer {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        if (this.props._rawDialog) {
            return this._renderDialogContent();
        }
        return React.createElement(ModalTransition, null, this._renderDialogContent());
    }
}
export default connect(abstractMapStateToProps)(DialogContainer);
